import { render } from "./PendingShipLog.vue?vue&type=template&id=0638d0aa"
import script from "./PendingShipLog.vue?vue&type=script&lang=js"
export * from "./PendingShipLog.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__